import { render, staticRenderFns } from "./BarraAvance.vue?vue&type=template&id=3c2c85fa&lang=pug&"
import script from "./BarraAvance.vue?vue&type=script&lang=js&"
export * from "./BarraAvance.vue?vue&type=script&lang=js&"
import style0 from "./BarraAvance.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports